export default "__VITE_ASSET__BjY6Tqxa__"